<template>
  <div class="jyutai-search">
    <TitleFrame text="渋滞予測" :dense="true">
      <template slot="contents">
        <RouteSearchInputs @click-search="onClickSearch" />
        <div class="map-area">
          <GoogleMapOnlyCurrent
            v-if="currentLat && currentLng"
            :current="current"
          />
        </div>
        <StartTimeSelectDialog
          v-if="showTimeList"
          :current="current"
          :timeRouteList="timeRouteList"
          :predictionStatus="predictionStatus"
        />
        <TripSurveyBanner/>
        <div class="app-banner">
          <AppBanner/>
        </div>
      </template>
    </TitleFrame>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TitleFrame from "@/components/Templates/TitleFrame";
import RouteSearchInputs from "@/components/Organisms/RouteSearchInputs";
import RouteSearchSpot from "@/components/Organisms/RouteSearchSpot";
import Caution from "@/components/RouteSearch/Caution";
import AppBanner from "@/components/Organisms/AppBanner";
import TripSurveyBanner from "@/components/JyutaiSearch/TripSurveyBanner";
import GoogleMapOnlyCurrent from "@/components/Organisms/GoogleMapOnlyCurrent";
import StartTimeSelectDialog from "@/components/JyutaiSearch/StartTimeSelectDialog";
import Firebase from "./../../firebase";
import axios from "axios";
import { IC_LIST_BEFORE, IC_LIST_AFTER } from "../../const.js";

const HACHIOUJI = new window.google.maps.LatLng(
  "35.64076604201434",
  "139.24668990833808",
);

const OHTSUKI = new window.google.maps.LatLng(
  "35.611605848542126",
  "138.93244394549106",
);

export default {
  name: "jyutai-search",
  components: {
    TitleFrame,
    RouteSearchInputs,
    RouteSearchSpot,
    GoogleMapOnlyCurrent,
    StartTimeSelectDialog,
    Caution,
    AppBanner,
    TripSurveyBanner,
  },
  props: {
    current: { type: String, default: false, required: true },
  },
  data() {
    return {
      timeList: [],
      timeRouteList: [],
      showTimeList: false,
      predictionStatus: 0,
    };
  },
  computed: {
    ...mapState([
      "currentLat",
      "currentLng",
      "DepLatLng",
      "DesLatLng",
      "search",
      "currentPageName",
    ]),
    currentDepLatLng() {
      if (this.current === "RouteSearch") {
        return this.DepLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DepLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DepLatLng.jyutai;
      }
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
    },
    currentSearch() {
      if (this.current === "RouteSearch") {
        return this.search.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.search.jyutai;
      }
    },
    currentSearchDep() {
      if (this.currentSearch.departure === "現在地") {
        return this.currentDepLatLng;
      }
      return this.currentSearch.departure;
    },
    currentSearchDes() {
      if (this.currentSearch.destination === "現在地") {
        return this.currentDesLatLng;
      }
      return this.currentSearch.destination;
    },
  },
  mounted() {
    this.generateDepTimeList();
  },
  methods: {
    ...mapMutations([
      "setSearch",
      "loadingStartMini",
      "loadingEndMini",
      "setSelectedTab",
      "setSearchState",
      "setDepLatLng",
      "setDesLatLng",
    ]),
    saveListToCookie(targetListName, targetData) {
      let deslist = this.$cookies.get(targetListName);
      if (deslist) {
        if (!deslist.filter((x) => x === targetData).length) {
          deslist.unshift(targetData);
          this.$cookies.set(targetListName, JSON.stringify(deslist));
        }
      } else {
        this.$cookies.set(targetListName, JSON.stringify([targetData]));
      }
    },
    generateDepTimeList() {
      this.timeList = [];
      this.timeRouteList = [];
      for (let i = 0; i < 4; i++) {
        var now = new Date();
        now.setHours(now.getHours() + i);
        this.timeList.push(now);
      }
    },
    async onClickSearch(e) {
      this.saveListToCookie("departurelist", e.departure);
      this.saveListToCookie("destionationlist", e.destination);
      this.setSearch(e);
      this.generateDepTimeList();
      await this.getGeo(e.departure, true);
      await this.getGeo(e.destination, false);
      await this.searchRoute();
    },
    getIsDuplicate(arr1, arr2) {
      if (this.currentSelectedFilter.tag.length === 0) return true;
      return (
        [...arr1, ...arr2].filter(
          (item) => arr1.includes(item) && arr2.includes(item),
        ).length > 0
      );
    },
    calcDistance(target1, target2) {
      const R = Math.PI / 180;
      let tmpLat = target1.lat();
      let tmpLng = target1.lng();
      let currentLat = target2.lat();
      let currentLng = target2.lng();
      currentLat *= R;
      currentLng *= R;
      tmpLat *= R;
      tmpLng *= R;
      return (
        6371 *
        Math.acos(
          Math.cos(currentLat) *
            Math.cos(tmpLat) *
            Math.cos(tmpLng - currentLng) +
            Math.sin(currentLat) * Math.sin(tmpLat),
        ) *
        1000
      );
    },
    async searchRoute() {
      this.loadingStartMini();
      this.showTimeList = false;
      this.predictionStatus = 0;
      const directionsService = new window.google.maps.DirectionsService();
      const timeRouteList = this.timeRouteList;
      const now = new Date();

      const actionParams = {
        start: this.currentSearch.departure,
        start_lon: this.currentDepLatLng.lng(),
        start_lat: this.currentDepLatLng.lat(),
        start_time: now,
        goal: this.currentSearch.destination,
        goal_lat: this.currentDesLatLng.lng(),
        goal_lon: this.currentDesLatLng.lat(),
        current_lat: this.currentLat,
        current_lon: this.currentLng,
      };

      Firebase.putLog({
        ActionType: "SearchRoute",
        ActionParams: actionParams,
      });

      await Promise.all(
        this.timeList.map(async (time, index) => {
          try {
            let targetTime = new Date(time);
            if (targetTime < new Date()) {
              targetTime = new Date();
            }
            const response = await directionsService.route({
              origin: this.currentSearchDep,
              destination: this.currentSearchDes,
              travelMode: window.google.maps.TravelMode.DRIVING,
              drivingOptions: {
                departureTime: targetTime,
                trafficModel: "bestguess",
              },
            });

            let resultDuration =
              response.routes[0].legs[0].duration_in_traffic.value;
            let target = new Date(targetTime);

            const text = JSON.stringify(response);
            if (
              Number(this.currentDesLatLng.lng()) > Number(HACHIOUJI.lng()) &&
              text.indexOf("中央自動車道") !== -1 &&
              IC_LIST_BEFORE.some((item) => text.indexOf(item) !== -1) &&
              IC_LIST_AFTER.some((item) => text.indexOf(item) !== -1)
            ) {
              let durationSum = 0;
              const result = await directionsService.route({
                origin: this.currentSearchDep,
                destination: OHTSUKI,
                travelMode: window.google.maps.TravelMode.DRIVING,
                drivingOptions: {
                  departureTime: target,
                  trafficModel: "bestguess",
                },
              });

              console.debug(
                `DEBUG0915:A出発地〜大月ICを検索:${index}: ${this.currentSearchDep}, ${target}, ${OHTSUKI}, ${Math.round(result.routes[0].legs[0].duration_in_traffic.value/60*100)/100}分`);

              target.setSeconds(
                target.getSeconds() +
                  result.routes[0].legs[0].duration_in_traffic.value,
              );

              durationSum = result.routes[0].legs[0].duration_in_traffic.value;

              // 現在とtargetの間の分数の差を求める
              const diff = Math.floor(
                (target.getTime() - new Date().getTime()) / 1000 / 60,
              );
              if (diff < 300) {
               
                const result2 = await axios.get(
                  "https://predict.traveltime.jp/t6hegs/?t=rct&acc=0",
                );
                
                // 追加: NEXCOAPIの提供する予測の計算を実施した時刻と出発時刻の差を考慮
                const nexco_api_calced_time = new Date(result2.data.data[0].datetime);
                const start_time = this.timeList[0];
                const diff2 = (start_time - nexco_api_calced_time) / 1000 / 60;
                //旧スイスイ旅に合わせる為index+1
                let num = Math.floor((diff +diff2) / 5) + 1;
                if (num > 65) {
                  num = 60;
                }

                
                const tyuoudo_min = result2.data.data[0].result[num];
                this.predictionStatus = result2.data.data[0].accident_status;
                target.setMinutes(target.getMinutes() + tyuoudo_min);
                durationSum = durationSum + tyuoudo_min * 60;
                 
                // todo dev
                console.debug(`DEBUG0915:BNEXCOAPIインデックスと時間時間:${index}:${index*60}, ${num}, ${tyuoudo_min}分`);

                const result3 = await directionsService.route({
                  origin: HACHIOUJI,
                  destination: this.currentSearchDes,
                  travelMode: window.google.maps.TravelMode.DRIVING,
                  drivingOptions: {
                    departureTime: target,
                    trafficModel: "bestguess",
                  },
                });

                console.debug(`DEBUG0915:C八王子JCT〜目的地を検索:${index}: ${HACHIOUJI}, ${target}, ${this.currentSearchDes}, ${Math.round(result3.routes[0].legs[0].duration_in_traffic.value/60*100)/100}分`);

                target.setSeconds(
                  target.getSeconds() +
                    result3.routes[0].legs[0].duration_in_traffic.value,
                );
                durationSum =
                  durationSum + 
                  result3.routes[0].legs[0].duration_in_traffic.value;

                console.debug(`DEBUG0915:Dトータル:${index}: ${Math.round(durationSum/60*100)/100}分`);

                resultDuration = durationSum;
              } else {
                // 300分越えた時はGooleMapAPIの結果だけ使う
                target = new Date(targetTime);
                resultDuration =
                  response.routes[0].legs[0].duration_in_traffic.value;
              }
            }

            timeRouteList.push({
              time,
              route: response,
              duration: resultDuration,
            });
          } catch (error) {
            window.alert(
              "経路検索時にエラーが発生しました。条件を変更するか、時間をあけて再度お試しください。",
            );
          }
        }),
      );

      // 全データはfirebaseの制約にひっかかってしまって入らないので一部だけ送る
      const formattedTimeRouteList = timeRouteList.map((item) => {
        return {
          time: item.time,
          route: {
            overview_polyline: item.route.routes[0].overview_polyline,
            summary: item.route.routes[0].summary,
          },
          duration: item.duration,
        };
      });
      Firebase.putLog({
        ActionType: "SearchRouteResults",
        ActionParams: actionParams,
        RelatedJsonData: JSON.stringify(formattedTimeRouteList),
      });

      this.loadingEndMini();

      this.timeRouteList.sort((a, b) => {
        return a.time.getTime() - b.time.getTime();
      });

      this.showTimeList = true;
    },
    async getGeo(text, dep) {
      const re = new RegExp("^[0-9]{1,3}.[0-9]*.* [0-9]{1,3}.[0-9]*");
      if (re.test(text)) {
        const coord = new RegExp("([0-9]{1,3}.[0-9]*)", "g");
        let parsedString = text.match(coord);
        let latlng = new window.google.maps.LatLng(
          parsedString[0],
          parsedString[1],
        );
        if (dep) {
          this.setDepLatLng(latlng);
        } else {
          this.setDesLatLng(latlng);
        }
        return;
      }
      if (text === "現在地") {
        let latlng = new window.google.maps.LatLng(
          this.currentLat,
          this.currentLng,
        );
        if (dep) {
          this.setDepLatLng(latlng);
        } else {
          this.setDesLatLng(latlng);
        }
        return;
      }
      var setDepLatLng = this.setDepLatLng;
      var setDesLatLng = this.setDesLatLng;
      var loadingEndMini = this.loadingEndMini;
      var geocoder = new window.google.maps.Geocoder();
      await geocoder.geocode(
        {
          address: text,
        },
        function (results, status) {
          if (status === window.google.maps.GeocoderStatus.OK) {
            for (var i in results) {
              if (results[0].geometry) {
                var latlng = results[0].geometry.location;
                if (dep) {
                  setDepLatLng(latlng);
                } else {
                  setDesLatLng(latlng);
                }
              }
            }
          } else if (
            status === window.google.maps.GeocoderStatus.ZERO_RESULTS
          ) {
            let tex = "目的地";
            if (dep) {
              tex = "出発地";
            }
            alert(tex + "が見つかりませんでした");
            loadingEndMini();
          } else {
            alert("GooleMapで場所情報取得中にエラーが発生しました");
          }
        },
      );
    },
  },
  async mounted() {
    // これはデバッグ用
    this.loadingStartMini();
    // await this.onClickSearch({
    //   departure: "富士急ハイランド",
    //   destination: "板橋駅",
    // });
    this.loadingEndMini();
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.jyutai-search {
  height: 100%;

  .map-area {
    height: calc(100% - 5.7rem);
  }
}
.app-banner
{
  position: fixed;
  right: 0.0rem;
  bottom: 2.0rem;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/JyutaiSearch.vue